import { render, staticRenderFns } from "./WarehousesPage.vue?vue&type=template&id=657a4cd5&scoped=true&"
import script from "./WarehousesPage.vue?vue&type=script&lang=js&"
export * from "./WarehousesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657a4cd5",
  null
  
)

export default component.exports